export const getThresholdColorMap = (theme) => {
  return {
    Red: theme.palette.facet.facetDesignErrorMain,
    Yellow: theme.palette.facet.colorSunset400,
    Green: theme.palette.facet.mint90p,
  };
};
